import React from "react";
import Card from "../../components/card";
import ico_ubicacion from "../../assets/icons/ico_ubicacion.svg";
import ico_especies_endemicas from "../../assets/icons/ico_especies_endemicas.svg";
import ico_especies_amenazadas from "../../assets/icons/ico_especies_amenazadas.svg";
import ico_especies_clave from "../../assets/icons/ico_especies_clave.svg";
import ico_especies_emblematicas from "../../assets/icons/ico_especies_emblematicas.svg";
import ico_especies_paraguas from "../../assets/icons/ico_especies_paraguas.svg";
import ico_especies_indicadoras from "../../assets/icons/ico_especies_indicadoras.svg";
import img_fondo_especies from "../../assets/images/img_fondo_especies.jpg";
import img_endemicas from "../../assets/images/img_endemicas.jpg";
import img_amenazadas from "../../assets/images/img_amenazadas.jpg";
import img_clave from "../../assets/images/img_clave.jpg";
import img_emblematicas from "../../assets/images/img_emblematicas.jpg";
import img_paraguas from "../../assets/images/img_paraguas.jpg";
import img_indicadoras from "../../assets/images/img_indicadoras.jpg";
import GoToPage from "../../components/goToPage";
import SpeciesInfo from "../../components/speciesInfo";
const SpeciesScreen = () => {
  return (
    <div className="relative">
      <div className="w-full h-full object-cover absolute  bg-[#062141]/60 z-10 "></div>

      <img
        loading="lazy"
        src={img_fondo_especies}
        className="w-full h-full object-cover absolute"
      ></img>

      <div className="w-full mx-auto text-white relative flex flex-col justify-center items-center z-10  pt-20">
        <div className="grid py-20 lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 pb-20 min-w-[10rem] gap-3 lg:w-full lx:px-64 lg:px-20 md:px-5 sm:px-5 px-10">
          <div className="lg:mb-20 md:mb-10 sm:mb-5 mb-5 lg:mt-20 md:mt-10 sm:mt-0 mt-0">
            <GoToPage
              page="/"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <div className="flex justify-center items-center">
            <img loading="lazy" src={ico_ubicacion} className="" alt=""></img>
          </div>
          <div className="lg:col-span-3 text-center break-words mb-10">
            <h1 className="lg:text-7xl md:text-4xl sm:text-4xl text-4xl font-bold mb-5">
              Especies para <br /> enfocar el monitoreo
            </h1>
            <div className="lg:mt-10 lg:mb-20">
              <p className="break-words text-lg lg:text-center md:tex-left sm:text-left text-left">
                Una lista de especies es uno de los resultados más importantes
                del trabajo de monitoreo al <br /> trabajar con el enfoque por
                grupos de fauna y flora.
              </p>
              <p className="break-words text-lg mt-5 lg:text-center md:tex-left sm:text-left text-left">
                Es a partir de esta lista que podemos definir con qué tipo de
                especies contamos y con
                <br /> cuales vamos a continuar el monitoreo, máxime porque
                monitorear toda la biodiversidad
                <br /> resulta una tarea casi imposible.
              </p>
            </div>
          </div>
          <Card
            image={img_endemicas}
            icon={ico_especies_endemicas}
            title={
              <h1 className="font-bold ">
                Especies <br /> Endemicas
              </h1>
            }
            page={"/especies/especies-endemicas"}
          ></Card>
          <Card
            image={img_amenazadas}
            icon={ico_especies_amenazadas}
            title={
              <h1 className="font-bold ">
                Especies <br /> Amenazadas
              </h1>
            }
            page={"/especies/especies-amenazadas"}
          ></Card>
          <Card
            image={img_clave}
            icon={ico_especies_clave}
            title={
              <h1 className="font-bold ">
                Especies <br /> Clave
              </h1>
            }
            page={"/especies/especies-clave"}
          ></Card>
          <Card
            image={img_emblematicas}
            icon={ico_especies_emblematicas}
            title={
              <h1 className="font-bold ">
                Especies <br /> Emblemáticas
              </h1>
            }
            page={"/especies/especies-emblematicas"}
          ></Card>
          <Card
            image={img_paraguas}
            icon={ico_especies_paraguas}
            title={
              <h1 className="font-bold ">
                Especies <br /> Paraguas
              </h1>
            }
            page={"/especies/especies-paraguas"}
          ></Card>
          <Card
            image={img_indicadoras}
            icon={ico_especies_indicadoras}
            title={
              <h1 className="font-bold lg:px-16">
                Especies <br /> Indicadoras
              </h1>
            }
            page={"/especies/especies-indicadoras"}
          ></Card>
        </div>

        <SpeciesInfo />
      </div>
    </div>
  );
};

export default SpeciesScreen;
